import { Validators } from '@angular/forms';
import { ErrorMessages, Rule } from '@ubud/form';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    14/06/2018
 */
export class RegisterInstitutionGovernmentRule extends Rule {
    public get errorMessages(): ErrorMessages {
        return {
            ministry: {
                required: (params: any) => 'Kementerian tidak boleh kosong',
            },
            sotk_number: {
                required: (params: any) => 'Nomor SOTK dan Tanda Daftar tidak boleh kosong',
            },
            sotk_file: {
                required: (params: any) => 'File SOTK tidak boleh kosong',
            },
            type: {
                required: (params: any) => 'Tipe tidak boleh kosong',
            },
            echelon: {
                required: (params: any) => 'Eselon tidak boleh kosong',
            },
        };
    }

    public get ministry(): Function {
        return Validators.required;
    }

    public get sotkNumber(): Function {
        return Validators.required;
    }

    public get sotkFile(): Function {
        return Validators.required;
    }

    public get type(): Function {
        return Validators.required;
    }

    public get echelon(): Function {
        return Validators.required;
    }

    public getFormControls(): { [p: string]: any } {
        return {
            ministry: ['', this.ministry],
            sotk_number: ['', this.sotkNumber],
            sotk_file: ['', this.sotkFile],
            type: ['', this.type],
            echelon: ['', this.echelon],
        };
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/rules/register-institution-government.rule.ts